import { defineAction } from '~/prix'
import userSyncAction from './userSync.action.json' with { type: 'json' }
import { z } from 'zod'

const userSyncDefinition = defineAction({
  ...userSyncAction,

  input: z.object({}),
  output: z.object({
    message: z.string(),
    userId: z.string(),
    cached: z.string(),
    userProfile: z.any(),
  }),
})

export default userSyncDefinition
